// @flow
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import debounce from 'lodash.debounce';
import Loading from 'components/Loading';
import {
  Spin,
} from 'antd';
import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import {
  inventoryItemsActions,
  inventoryPrinterLabelActions,
  invoiceDetailsAction,
  sequenceGeneratorsActions,
} from 'store/actions';
import { NOTIFICATION } from 'store/actionTypes';
import {
  PAGES,
  API_STATUS,
  INVOICE_TYPES,
  MESSAGES,
} from 'appconstants';
import View from './components/ViewInvoice';
import Edit from './components/EditInvoice';
import InvoicePaymentDetails from './components/InvoicePaymentDetails';

type Props = {
  fetchInvoiceDetails: Function,
  invoiceDetails: Object,
  invoiceDetailsStatus: String,
  selectedAccount: Object,
  history: {
    push: Function,
  },
  loading: boolean,
  updateInvoice: Function,
  getCustomersList: Function,
  customersList: Array<Object>,
  submitting: boolean,
  validator: boolean,
  addedNewCustomer: Object,
  addCustomer: Function,
  deleteInvoice: Function,
  getProductsList: Function,
  productsList: Array<Object>,
  addNewProcut: Function,
  setNotification: Function,
  notifyInvoice: Function,
  addedNewProduct: Object,
  addNewCoupon: Function,
  getTaxes: Function,
  taxList:Array<Object>,
  addNewTaxRate: Function,
  newCoupon: Object,
  newTaxrate: Object,
  cancelInvoices: Function,
  refundInvoices: Function,
  fetchAllInvoiceSequence:Function,
  invoiceSeqNo:Array,
  fetchInventoryItems: Function,
  inventoryItems: Array,
  modifierItemsList: Array<Object>,
  fetchItemsList: Function,
  fetchModifierItemsList: Function,
  fetchPrinterLabelList: Function,
  itemsList: Array,
  labelList: Array,
  addedNewItem: Object,
  addInventoryItems: Function,
  fetchInvoicePaymentDetails: Function,
  invoicePaymentDetails: Array,
};

const InvoiceDetails = (props: Props) => {
  const {
    fetchInvoiceDetails,
    invoiceDetails,
    invoiceDetailsStatus,
    selectedAccount,
    history,
    loading,
    updateInvoice,
    getCustomersList,
    customersList,
    submitting,
    validator,
    addedNewCustomer,
    addCustomer,
    deleteInvoice,
    getProductsList,
    productsList,
    addNewProcut,
    setNotification,
    notifyInvoice,
    addedNewProduct,
    addNewCoupon,
    getTaxes,
    taxList,
    addNewTaxRate,
    newCoupon,
    newTaxrate,
    cancelInvoices,
    refundInvoices,
    fetchAllInvoiceSequence,
    invoiceSeqNo,
    fetchInventoryItems,
    inventoryItems,
    modifierItemsList,
    fetchItemsList,
    fetchModifierItemsList,
    fetchPrinterLabelList,
    itemsList,
    labelList,
    addedNewItem,
    addInventoryItems,
    fetchInvoicePaymentDetails,
    invoicePaymentDetails,
  } = props;
  const location = useLocation();
  // eslint-disable-next-line react/prop-types
  const { gid } = props.match.params;
  // eslint-disable-next-line react/prop-types
  const gidPath = gid.split('-')[1];
  const [zipTag, setZipTag] = useState('');
  const [redirect, setRedirect] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isEnableGenerationInvoiceNo, setIsEnableGenerationInvoiceNo] = useState(false);

  const getData = (query) => {
    // eslint-disable-next-line no-shadow
    const parsed = queryString.parse(query);
    const currentPage = parsed.pageNum || 1;
    const sortBy = parsed.sortBy || 'name';
    const direction = parsed.direction || 'ASC';
    const sortParams = `&sortBy=${sortBy}&direction=${direction}`;
    fetchInvoiceDetails(gid);
    getCustomersList();
    getProductsList();
    fetchInvoicePaymentDetails(gid);
    if (!(selectedAccount && selectedAccount.legacySubscription)) {
      fetchInventoryItems({ currentPage, sortParams });
      fetchItemsList('&sortBy=name&direction=DESC');
      fetchModifierItemsList('&sortBy=name&direction=DESC');
      fetchPrinterLabelList('&sortBy=createdAt&direction=DESC');
      fetchAllInvoiceSequence('INVOICE');
    }
  };

  useEffect(() => {
    getData(location.search);
    fetchAllInvoiceSequence('INVOICE');
  }, []);
  useEffect(() => {
    if (invoiceSeqNo && invoiceSeqNo.length > 0) {
      setIsEnableGenerationInvoiceNo(invoiceSeqNo[0]?.enableGeneration);
    }
  }, [invoiceSeqNo]);
  useEffect(() => {
    if (selectedAccount && selectedAccount.country) {
      if (selectedAccount.country.id === 1) {
        setZipTag('Zip code');
      } else if (selectedAccount.country.id === 2) {
        setZipTag('Pin code');
      }
    }
  }, [selectedAccount]);

  useEffect(() => {
    if (!gidPath) {
      history.push(PAGES.INVOICES);
    }
  }, []);

  useEffect(() => {
    if (!validator && redirect) {
      history.push(PAGES.INVOICES);
    }
  }, [validator]);

  const getProducts = (searchText: string) => {
    getProductsList(searchText);
  };

  const debouncedFetchInventoryItems = debounce(fetchInventoryItems, 2000, { leading: true });
  const getInventryItems = (searchText: string) => {
    const sortParams = '&sortBy=name&direction=ASC';
    const currentPage = 1;
    const filterParams = '';
    debouncedFetchInventoryItems({
      currentPage, sortParams, filterParams, nameSearch: searchText ? (searchText === '' ? null : `&name.LIKE=${searchText}`) : null,
    });
  };

  const sendInvoice = () => {
    const params = {
      type: 'ALL',
    };
    notifyInvoice({
      gid,
      params,
    });
  };

  const invoiceUpdate = (payload: Object) => {
    let endPoint;
    const { params } = payload;
    const { status } = params;

    if (status === 'DRAFT') {
      endPoint = 'draft';
    } else if (status === 'ACTIVE') {
      endPoint = 'active';
    }

    updateInvoice({
      gid,
      endPoint,
      params,
    });
  };

  const createNewInvoice = () => {
    history.push(`${PAGES.NEW_INVOICE}?INVOICE.ID=${gid}`);
  };

  const cancelInvoice = () => {
    const params = {
      status: 'CANCELLED',
    };
    cancelInvoices({
      gid,
      params,
    });
    setRedirect(true);
  };

  const refundInvoice = (refund: object) => {
    const {
      amount,
      reason,
      note,
    } = refund;
    const currency = amount;
    const params = {
      refundReason: reason,
      amountRefunded: Number(currency),
      refundNote: note,
    };
    refundInvoices({
      gid,
      params,
    });
    setRedirect(true);
  };

  const deleteInvoices = () => {
    const params = {
      status: 'CANCELLED',
    };
    deleteInvoice({
      gid,
      params,
    });
    setRedirect(true);
  };

  const updatePartialPaymentDetails = (invoice: Object) => {
    const params = {
      expiryDate: invoice?.expiryDate,
      invoiceTermsAndConditions: {
        initialAmount: invoice?.initialAmount,
        lateFee: invoice?.lateFee,
        graceDays: invoice?.graceDays,
        overdueInterest: invoice?.overdueInterest,
        pendingAmount: invoice?.pendingAmount,
      },
    };
    updateInvoice({
      gid,
      endPoint: 'active',
      params,
    });
  };

  const searchCustomers = (searchParams: string) => {
    getCustomersList(searchParams);
  };

  const customerAdd = (params: Object) => {
    addCustomer(params);
  };

  const productAdd = (params: Object) => {
    addNewProcut(params);
  };

  const invoiceDownload = async () => {
    const pdfKey = invoiceDetails.invoicePdfKey;
    setLoader(true);
    try {
      const { data: { entity: { fileUrl } } } = await axiosAuthInstance
        .get(`${API_END_POINTS.INVOICE_API}/${pdfKey}/download`);
      window.open(fileUrl);
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: MESSAGES.INVOICE.DOWNLOAD_ERROR,
      });
    } finally {
      setLoader(false);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <div className={loader ? 'OVERLAY' : ''}>
        {
          loader && (
            <Spin style={{ width: '100%', height: '100%', transform: 'translateY(50%)' }} />
          )
        }
      </div>
      {
        invoiceDetails.gid && invoiceDetailsStatus === API_STATUS.SUCCESS && (
          <>
            {
              invoiceDetails.status === INVOICE_TYPES.DRAFT ? (
                <Edit
                  gid={gid}
                  invoiceDetails={invoiceDetails}
                  selectedAccount={selectedAccount}
                  invoiceUpdate={invoiceUpdate}
                  deleteInvoices={deleteInvoices}
                  customersList={customersList}
                  searchCustomers={searchCustomers}
                  submitting={submitting}
                  zipTag={zipTag}
                  validator={validator}
                  addedNewCustomer={addedNewCustomer}
                  customerAdd={customerAdd}
                  getProducts={getProducts}
                  productsList={productsList}
                  productAdd={productAdd}
                  addedNewProduct={addedNewProduct}
                  createNewInvoice={createNewInvoice}
                  addNewCoupon={addNewCoupon}
                  getTaxes={getTaxes}
                  taxList={taxList}
                  addNewTaxRate={addNewTaxRate}
                  newCoupon={newCoupon}
                  newTaxrate={newTaxrate}
                  isEnableGenerationInvoiceNo={isEnableGenerationInvoiceNo}
                  modifierItemsList={modifierItemsList}
                  fetchPrinterLabelList={fetchPrinterLabelList}
                  labelList={labelList}
                  itemsList={itemsList}
                  addedNewItem={addedNewItem}
                  addInventoryItems={addInventoryItems}
                  getInventryItems={getInventryItems}
                  inventoryItems={inventoryItems}
                />
              ) : (
                <View
                  gid={gid}
                  invoiceDetails={invoiceDetails}
                  selectedAccount={selectedAccount}
                  sendInvoice={sendInvoice}
                  cancelInvoice={cancelInvoice}
                  refundInvoice={refundInvoice}
                  validator={validator}
                  submitting={submitting}
                  invoiceDownload={invoiceDownload}
                  createNewInvoice={createNewInvoice}
                  updatePartialPaymentDetails={updatePartialPaymentDetails}
                />
              )
            }
            <InvoicePaymentDetails
              paymentDetails={invoicePaymentDetails}
              selectedAccount={selectedAccount}
            />
          </>

        )
      }
    </>

  );
};

const mapStateToProps = (state) => ({
  invoiceDetails: state.invoiceDetails.invoice,
  selectedAccount: state.account.selectedAccount,
  submitting: state.loading.submitting,
  validator: state.loading.validator,
  loading: state.loading.loading,
  invoiceDetailsStatus: state.invoiceDetails.invoiceDetailsStatus,
  customersList: state.invoiceDetails.customersList,
  addedNewCustomer: state.invoiceDetails.newCustomer,
  productsList: state.invoiceDetails.productsList,
  addedNewProduct: state.invoiceDetails.newProduct,
  taxList: state.invoiceDetails.taxList,
  newCoupon: state.invoiceDetails.newCoupon,
  newTaxrate: state.invoiceDetails.newTaxrate,
  currentInvoiceSeqNo: state.sequenceGenerators.currentSequence,
  invoiceSeqNo: state.sequenceGenerators.invoiceSequence.content,
  modifierItemsList: state.inventoryItems.modifierItemsList.content,
  itemsList: state.inventoryItems.itemsList.content,
  labelList: state.inventoryPrinterLabel.labelList.content,
  addedNewItem: state.inventoryItems.addedItem.entity,
  inventoryItems: state.inventoryItems.content,
  invoicePaymentDetails: state.invoiceDetails.paymentDetails,
});

const mapDispatchToProps = (dispatch) => ({
  fetchInvoiceDetails: gid => dispatch(invoiceDetailsAction.fetchInvoiceDetails({
    payload: gid,
  })),
  updateInvoice: param => dispatch(invoiceDetailsAction.updateInvoice({
    payload: param,
  })),
  getCustomersList: param => dispatch(invoiceDetailsAction.getCustomersList({
    payload: param,
  })),
  addCustomer: param => dispatch(invoiceDetailsAction.addCustomer({
    payload: param,
  })),
  deleteInvoice: param => dispatch(invoiceDetailsAction.deleteInvoice({
    payload: param,
  })),
  cancelInvoices: param => dispatch(invoiceDetailsAction.cancelInvoices({
    payload: param,
  })),
  refundInvoices: param => dispatch(invoiceDetailsAction.refundInvoices({
    payload: param,
  })),
  getProductsList: param => dispatch(invoiceDetailsAction.getProductsList({
    payload: param,
  })),
  addNewProcut: param => dispatch(invoiceDetailsAction.addNewProcut({
    payload: param,
  })),
  notifyInvoice: param => dispatch(invoiceDetailsAction.notifyInvoice({
    payload: param,
  })),
  addNewCoupon: param => dispatch(invoiceDetailsAction.addNewCoupon({
    payload: param,
  })),
  getTaxes: param => dispatch(invoiceDetailsAction.getTaxes({
    payload: param,
  })),
  addNewTaxRate: param => dispatch(invoiceDetailsAction.addNewTaxRate({
    payload: param,
  })),
  fetchAllInvoiceSequence: param => dispatch(sequenceGeneratorsActions.fetchAllInvoiceSequence({
    payload: param,
  })),
  fetchPrinterLabelList: (payload) => dispatch(inventoryPrinterLabelActions.fetchPrinterLabelList({
    payload,
  })),
  addInventoryItems: param => dispatch(inventoryItemsActions.addInventoryItems({
    payload: param,
  })),
  fetchInventoryItems: param => dispatch(inventoryItemsActions.fetchInventoryItems({
    payload: param,
  })),
  fetchItemsList: param => dispatch(inventoryItemsActions.fetchItemsList({
    payload: param,
  })),
  fetchModifierItemsList: param => dispatch(inventoryItemsActions.fetchModifierItemsList({
    payload: param,
  })),
  fetchInvoicePaymentDetails: param => dispatch(invoiceDetailsAction.fetchInvoicePaymentDetails({
    payload: param,
  })),
});

// $FlowFixMe
export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDetails);
